import type { ComponentProps, ElementType } from "react";
import { useExitLink, type ExitLinkProps } from "../hooks/useExitLink";

type ExitLinkComponent<T extends ElementType> = {
  as?: T;
} & ExitLinkProps &
  ComponentProps<T> & { href: string };

export function ExitLink<T extends ElementType = "a">(
  props: ExitLinkComponent<T>,
) {
  const {
    as,
    href,
    exitPoint,
    kind,
    agencyIds,
    provider,
    partnerPage,
    onExit,
    children,
    ...rest
  } = props;

  const [decoratedUrl, handleExit] = useExitLink({
    href,
    exitPoint,
    kind,
    agencyIds,
    provider,
    partnerPage,
    onExit,
  });

  const Component = as || "a";

  return (
    <Component {...rest} href={decoratedUrl} onClick={handleExit}>
      {children}
    </Component>
  );
}
